import { httpClient2 } from "../utils/httpClient2";

import { CustomView, CustomViewType } from "../types/entities";
import { EditCustomViewDto } from "../types/dto";

export const fetchCustomViews = async ({
  view_type
}: {
  view_type: CustomViewType;
}) => {
  const response = await httpClient2.get<CustomView[]>("/custom_views", {
    params: { view_type }
  });

  return response.data;
};

export const createCustomView = async ({
  view
}: {
  view: Omit<CustomView, "id" | "user_id">;
}) => {
  const response = await httpClient2.post<CustomView>("/custom_views", {
    ...view
  });

  return response.data;
};

export const editCustomView = async (dto: EditCustomViewDto) => {
  const { id, ...data } = dto;

  const response = await httpClient2.put(`/custom_views/${id}`, data);

  return response.data;
};

export const deleteCustomView = async ({ id }: { id: number }) => {
  const response = await httpClient2.delete(`/custom_views/${id}`);

  return response.data;
};
